import capitalize from '@/commons/formatters/capitalize';
import { paymentMethods } from '@/apps/payin/payment-link/constants/paymentMethods';

export const formatedPaymentMethods = methods =>
  methods.map(paymentMethod => capitalize(paymentMethods[paymentMethod])).join(', ');
